import axios from 'axios'

import {
  type IGetSummaryResponse,
  type IAirframe
} from 'platform-core'
import {
  type IAirframeTransfer,
  type BaseResponse,
  type CreateIntentResponse
} from '@/models'
import { API_ENDPOINT } from '@/util/constants'

export class BillingService {
  async getSummary (userId: string): Promise<IGetSummaryResponse> {
    let data: IGetSummaryResponse
    try {
      ({ data } = await axios.post<IGetSummaryResponse>(
        `${API_ENDPOINT}/v1/billing/sign-up/summary`,
        { userId }
      ))
    } catch (e: any) {
      throw new Error(e)
    }
    if (!data.success) {
      throw new Error(data.message)
    }
    return data
  }

  async markAsComplete (userId: string): Promise<void> {
    let data: BaseResponse
    try {
      ({ data } = await axios.put<BaseResponse>(
        `${API_ENDPOINT}/v1/billing/sign-up/complete`,
        { userId }
      ))
    } catch (e: any) {
      throw new Error(e)
    }
    if (!data.success) {
      throw new Error(data.message)
    }
  }

  async createIntent (userId: string, airframes: IAirframe[], transfers: IAirframeTransfer[]): Promise<string> {
    let data: CreateIntentResponse
    try {
      ({ data } = await axios.post<CreateIntentResponse>(
        `${API_ENDPOINT}/v1/billing/sign-up/intent`,
        { userId, airframes, transfers }
      ))
    } catch (e: any) {
      throw new Error(e)
    }
    if (!data.success) {
      throw new Error(data.message)
    }
    return data.clientSecret
  }
}
